module.exports = __webpack_public_path__ + "static/img/fluent-document-bullet-list-24-regular.85269877.svg";